module.exports = __webpack_public_path__ + "static/img/gsjs_tu1.d9435de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_tu1.png
// module id = oqfP
// module chunks = 0